import { addProvider } from '../metaData.js';
const VIEWPORT_V2_DISPLAY_SET = 'genericViewportDisplaySet';
const state = new Map();
const genericViewportDisplaySetMetadataProvider = {
    VIEWPORT_V2_DISPLAY_SET,
    add(displaySetId, dataSet) {
        state.set(displaySetId, dataSet);
    },
    get(type, displaySetId) {
        if (type !== VIEWPORT_V2_DISPLAY_SET) {
            return;
        }
        return state.get(displaySetId);
    },
    remove(displaySetId) {
        state.delete(displaySetId);
    },
    clear() {
        state.clear();
    },
};
addProvider(genericViewportDisplaySetMetadataProvider.get);
export default genericViewportDisplaySetMetadataProvider;
